export const POLICY_INHERITANCE_TAG_CLASSES =
  'inline-flex items-center whitespace-nowrap gap-1 text-9px px-2 py-1.5 abc-regular leading-none rounded-full hover:text-dope-cyan-300 bg-dope-teal-300 text-dope-cyan-bright'
